export function normalizeText(value: unknown): string {
    return String(value ?? '').trim().toLowerCase();
}

export function includesNormalized(haystack: unknown, needle: unknown): boolean {
    const normalizedNeedle = normalizeText(needle);
    if (!normalizedNeedle) return true;
    return normalizeText(haystack).includes(normalizedNeedle);
}

export function hasPositiveNumber(value: unknown): boolean {
    const parsed = Number(value ?? 0);
    return Number.isFinite(parsed) && parsed > 0;
}
